import { BaseHTMLAttributes } from '@mi-front/core';
import { CircularProgress, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { palette } from '@ui/styles';
import classNames from 'classnames';
import omit from 'lodash/omit';

const StyledMenu = styled('div')(({ theme }) => ({
  display: 'flex',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '1.5rem',
  padding: '0 0.5rem',
  background: theme.palette.common.white,
  opacity: 1,
  transition: 'opacity 0.2s',
  '& button': {
    color: '#444',
    border: 'none',
    marginLeft: 0,
    '&:active:enabled': {
      boxShadow: 'none',
    },
    '&:hover': {
      color: palette.aqua, // $color-Aqua
    },
  },
}));

export interface MenuAction {
  readonly icon: React.ReactNode;
  readonly onClick: () => void;
  readonly tooltip: React.ReactNode;
  readonly enabled?: boolean;
  readonly loading?: boolean;
  readonly btnProps?: Partial<Omit<IconButtonProps, 'onClick' | 'children'>> & {
    'data-testid'?: string;
  };
}

interface Props extends BaseHTMLAttributes {
  readonly actions: readonly MenuAction[];
}

export function Menu(p: Props) {
  return (
    <StyledMenu className={classNames('el-menu', p.className)}>
      {p.actions.map(
        ({ icon, onClick, tooltip, enabled, loading, btnProps }, index) =>
          enabled !== false && (
            <Tooltip key={index} placement="top" title={tooltip}>
              <IconButton
                color="inherit"
                disabled={loading}
                onClick={onClick}
                {...omit(btnProps || {}, 'onClick', 'children')}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" sx={{ color: 'action.disabled' }} />
                ) : (
                  icon
                )}
              </IconButton>
            </Tooltip>
          ),
      )}
    </StyledMenu>
  );
}
